let appId = '';
let auth = '';
let logoutUrl = '';
let dataSourceId = '';
let scHost = '';

switch (process.env.NODE_ENV) {
  case 'dev':
    appId = '110104';
    auth = '115DE01A786747A4B96FF1A4A8A8AA69';
    logoutUrl = `http://uni-test.bestwehotel.net/unify/login.html?redirect=${encodeURIComponent('http://gzt-test.bestwehotel.net')}&appId=` + appId;
    dataSourceId = '88c0678ab55b9645';
    scHost = 'https://sensors-collect-test.bestwehotel.com/sa?project=default';
    break;
  case 'test':
    appId = '110104';
    auth = '115DE01A786747A4B96FF1A4A8A8AA69';
    logoutUrl = `http://uni-test.bestwehotel.net/unify/login.html?redirect=${encodeURIComponent('http://gzt-test.bestwehotel.net')}&appId=` + appId;
    dataSourceId = '88c0678ab55b9645';
    scHost = 'https://sensors-collect-test.bestwehotel.com/sa?project=default';
    break;
  case 'preprod':
    appId = '110078';
    auth = 'DECF96AB027547A28588FC779D169717';
    logoutUrl = `http://unipoc.bestwehotel.com/unify/login.html?redirect=${encodeURIComponent('http://gzt-pre.bestwehotel.com')}&appId=` + appId;
    dataSourceId = '88c0678ab55b9645';
    scHost = 'https://sensors-collect-test.bestwehotel.com/sa?project=default';
    break;
  case 'prod':
    appId = '110082';
    auth = '9648EA86CFF94F929715FCA735D45F1F';
    logoutUrl = `https://uni.bestwehotel.com/unify/login.html?redirect=${encodeURIComponent('https://gzt.bestwehotel.com')}&appId=` + appId;
    dataSourceId = 'f4a5b6c7d8e9f0a1';
    scHost = 'https://sensors-collect-prod.bestwehotel.com/sa?project=production';
    break;
}

export {
  appId,
  auth,
  logoutUrl,
  dataSourceId,
  scHost
};



// WEBPACK FOOTER //
// ./src/assets/js/env.js